import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'giq-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaginationComponent {
  @Input() collectionSize = 0;
  @Input() pageSize = 10;
  @Input() maxSize = 5;
  @Input() page = 1;

  @Output() pageChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.collectionSize / this.pageSize);
  }

  get pages(): number[] {
    const total = this.totalPages;
    const half = Math.floor(this.maxSize / 2);

    let start = Math.max(1, this.page - half);
    let end = start + this.maxSize - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - this.maxSize + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.page = page;
      this.pageChange.emit(this.page);
    }
  }

  goToPage(event: Event) {
    const input = event.target as HTMLInputElement;
    let targetPage = Number(input.value);

    if (!isNaN(targetPage)) {
      targetPage = Math.max(1, Math.min(this.totalPages, targetPage));
      this.changePage(targetPage);
    }
  }
}
